module.exports = __webpack_public_path__ + "static/kwame-taylor-hayford-81948561c89bf2920cfa6a67f42d778f.jpg";